export const pageTypes = {
	SET_SECTION: 'SET_SECTION',
};

export const setSection = (payload) => ({
	type: pageTypes.SET_SECTION,
	payload,
});
